var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.799805C16.4477 0.799805 16 1.24752 16 1.7998V5.5998H12.2C11.6477 5.5998 11.2 6.04752 11.2 6.5998C11.2 7.15209 11.6477 7.5998 12.2 7.5998H17C17.5523 7.5998 18 7.15209 18 6.5998V1.7998C18 1.24752 17.5523 0.799805 17 0.799805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9834 2.39284C11.3985 -0.178031 7.42567 -0.73383 4.23392 1.0306C1.03762 2.79755 -0.604839 6.4654 0.205549 10.0265C1.01594 13.5877 4.08381 16.1836 7.72997 16.3935C11.3761 16.6033 14.7216 14.3765 15.9352 10.9319C16.1187 10.411 15.8452 9.83991 15.3243 9.65639C14.8034 9.47287 14.2323 9.74637 14.0488 10.2673C13.1312 12.8718 10.6017 14.5555 7.84488 14.3968C5.08804 14.2381 2.76842 12.2753 2.15569 9.58276C1.54296 6.89019 2.78482 4.11694 5.20154 2.78095C7.61825 1.44497 10.6272 1.86831 12.5815 3.81927C12.5886 3.8264 12.5959 3.83341 12.6032 3.84032L16.3152 7.32832C16.7177 7.70651 17.3506 7.68682 17.7288 7.28434C18.1069 6.88186 18.0873 6.24901 17.6848 5.87081L13.9834 2.39284Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.8c58aeb8e58cdef35bccf880a56de3a5.svg";
export { ForwardRef as ReactComponent };